import React, { useState, useEffect } from 'react';
import ThemeToggle from '../components/ThemeToggle';
import anxietyCover from '../images/capa-anxiety_simples.png';
import ebookCover from '../images/capa_primeiro_passo.png'; // Nova imagem da capa do eBook

const LeadCaptureTestB = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    whatsapp: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [urgencyCounter, setUrgencyCounter] = useState(97); // Contador de vagas

  useEffect(() => {
    // Verificar se o modo escuro está ativo
    setIsDarkMode(document.body.classList.contains('dark-mode'));
    
    // Função para detectar dispositivo móvel
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
      const isSmallScreen = window.innerWidth <= 768;
      return isMobileDevice || isSmallScreen;
    };
    
    // Definir se é móvel na inicialização
    setIsMobile(checkIfMobile());
    
    // Configurar observador para mudanças no modo escuro
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class' && mutation.target === document.body) {
          setIsDarkMode(document.body.classList.contains('dark-mode'));
        }
      });
    });
    
    // Listener para mudanças no tamanho da tela
    const handleResize = () => {
      setIsMobile(checkIfMobile());
    };
    
    observer.observe(document.body, { attributes: true });
    window.addEventListener('resize', handleResize);
    window.scrollTo(0, 0);

    // Google Analytics - Teste B
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: 'Lead Capture Test B - Anxiety Focus',
        page_location: window.location.href,
        test_version: 'B'
      });
    }

    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'page_loaded',
        'page_type': 'lead_capture_test_b',
        'page_name': 'Webinar Ansiedade Alexandre Cecim',
        'test_version': 'B'
      });
    }

    // Simulador de urgência - diminuir vagas a cada 30 segundos
    const urgencyTimer = setInterval(() => {
      setUrgencyCounter(prev => {
        const newCount = prev - Math.floor(Math.random() * 2) - 1;
        return newCount > 15 ? newCount : 15; // Mínimo de 15 vagas
      });
    }, 30000);

    // Tracking de Scroll Behavior
    let scrollTracked = {
      '25': false,
      '50': false,
      '75': false,
      '90': false
    };
    
    const handleScroll = () => {
      const scrollPercent = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
      
      Object.keys(scrollTracked).forEach(percent => {
        if (scrollPercent >= parseInt(percent) && !scrollTracked[percent]) {
          scrollTracked[percent] = true;
          
          // Google Tag Manager - Scroll Event
          if (window.dataLayer) {
            window.dataLayer.push({
              'event': 'scroll_depth',
              'scroll_percent': percent,
              'page_type': 'lead_capture'
            });
          }
        }
      });
    };
    
    // Tracking de tempo na página
    const startTime = Date.now();
    const timeTracker = setInterval(() => {
      const timeOnPage = Math.round((Date.now() - startTime) / 1000);
      
      // Marcar marcos de tempo (30s, 60s, 120s)
      if ([30, 60, 120].includes(timeOnPage)) {
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'time_on_page',
            'time_seconds': timeOnPage,
            'page_type': 'lead_capture'
          });
        }
      }
    }, 1000);
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
      clearInterval(urgencyTimer);
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const formatWhatsApp = (value) => {
    // Remove tudo que não é número
    const numbers = value.replace(/\D/g, '');
    
    // Aplica a máscara (xx) xxxxx-xxxx
    if (numbers.length <= 11) {
      return numbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    
    return value;
  };

  const handleWhatsAppChange = (e) => {
    const formatted = formatWhatsApp(e.target.value);
    setFormData(prev => ({
      ...prev,
      whatsapp: formatted
    }));
  };

  const validateForm = () => {
    const { name, email, whatsapp } = formData;
    
    if (!name.trim()) {
      setSubmitMessage('Por favor, digite seu nome.');
      return false;
    }
    
    if (!email.trim()) {
      setSubmitMessage('Por favor, digite seu email.');
      return false;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setSubmitMessage('Por favor, digite um email válido.');
      return false;
    }
    
    if (!whatsapp.trim()) {
      setSubmitMessage('Por favor, digite seu WhatsApp.');
      return false;
    }
    
    // Validar WhatsApp (deve ter pelo menos 10 dígitos)
    const whatsappNumbers = whatsapp.replace(/\D/g, '');
    if (whatsappNumbers.length < 10) {
      setSubmitMessage('Por favor, digite um número de WhatsApp válido.');
      return false;
    }
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitMessage('');
    
    if (!validateForm()) {
      setTimeout(() => setSubmitMessage(''), 3000);
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Limpar WhatsApp para enviar apenas números
      const whatsappClean = formData.whatsapp.replace(/\D/g, '');
      
      const response = await fetch('/api/capture-lead', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name.trim(),
          email: formData.email.toLowerCase().trim(),
          whatsapp: whatsappClean,
          language: 'pt',
          source: 'lead-capture-test-b-anxiety'
        }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSubmitSuccess(true);
        setShowModal(true);
        
        // Google Analytics Events - Teste B
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            event_category: 'Lead Capture Test B',
            event_label: 'Form Submission Success - Anxiety Focus',
            test_version: 'B',
            value: 1
          });
        }
        
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'form_submit_success',
            'form_type': 'lead_capture_test_b',
            'lead_source': 'lead-capture-test-b-anxiety',
            'test_version': 'B',
            'conversion_value': 50,
            'currency': 'BRL',
            'lead_quality': 'high',
            'event_category': 'Lead Generation Test B',
            'event_action': 'Form Submit',
            'event_label': 'Anxiety Webinar Lead'
          });
        }
        
        setFormData({ name: '', email: '', whatsapp: '' });
        setSubmitMessage('');
      } else {
        if (response.status === 409) {
          setSubmitMessage('Este email já está cadastrado em nossa base de dados.');
        } else {
          setSubmitMessage(data.message || 'Erro ao registrar dados. Tente novamente.');
        }
        setTimeout(() => setSubmitMessage(''), 4000);
      }
    } catch (error) {
      console.error('Erro ao enviar dados:', error);
      setSubmitMessage('Erro de conexão. Verifique sua internet e tente novamente.');
      setTimeout(() => setSubmitMessage(''), 4000);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Função para rolar suavemente até o formulário
  const scrollToForm = () => {
    const formElement = document.getElementById('formulario-webinar-card');
    if (formElement) {
      formElement.scrollIntoView({ 
        behavior: 'smooth',
        block: 'center'
      });
      
      // Google Analytics - CTA Click
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'cta_click',
          'cta_type': 'urgency_scroll_to_form',
          'cta_location': 'page_content',
          'test_version': 'B'
        });
      }
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh',
      background: isDarkMode 
        ? 'linear-gradient(135deg, #7c2d12 0%, #dc2626 50%, #991b1b 100%)'
        : 'linear-gradient(135deg, #dc2626 0%, #ef4444 50%, #f87171 100%)',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
        <ThemeToggle />
      </div>

      {/* CTA Fixo no Topo - Versão Urgência */}
      <div style={{
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        backgroundColor: isDarkMode ? 'rgba(239, 68, 68, 0.95)' : 'rgba(220, 38, 38, 0.95)',
        color: 'white',
        padding: '0.75rem',
        textAlign: 'center',
        zIndex: 999,
        backdropFilter: 'blur(10px)',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        animation: 'pulse 2s infinite'
      }}>
        <button
          onClick={scrollToForm}
          style={{
            background: 'none',
            border: `2px solid white`,
            color: 'white',
            padding: '0.5rem 1.5rem',
            borderRadius: '25px',
            fontWeight: 'bold',
            cursor: 'pointer',
            fontSize: '0.9rem',
            transition: 'all 0.2s',
            textTransform: 'uppercase'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'white';
            e.target.style.color = isDarkMode ? '#dc2626' : '#b91c1c';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = 'white';
          }}
        >
          🔥 GARANTIR VAGA AGORA - {urgencyCounter} RESTANTES
        </button>
      </div>

      <div style={{
        backgroundColor: isDarkMode ? 'rgba(31, 41, 55, 0.95)' : 'rgba(255, 255, 255, 0.95)',
        padding: '3rem',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '500px',
        boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(10px)',
        border: isDarkMode ? '1px solid rgba(75, 85, 99, 0.3)' : '1px solid rgba(229, 231, 235, 0.3)',
        marginTop: '60px' // Espaço para o CTA fixo
      }}>
        {/* CTA de Urgência Transformado em Botão */}
        <button
          onClick={scrollToForm}
          style={{
            width: '100%',
            backgroundColor: isDarkMode ? '#dc2626' : '#ef4444',
            color: 'white',
            padding: '1rem',
            borderRadius: '8px',
            border: 'none',
            fontSize: '1rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'all 0.3s',
            marginBottom: '1.5rem',
            animation: 'pulse 2s infinite',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            boxShadow: '0 4px 15px rgba(239, 68, 68, 0.4)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = isDarkMode ? '#b91c1c' : '#dc2626';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 8px 25px rgba(239, 68, 68, 0.5)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = isDarkMode ? '#dc2626' : '#ef4444';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(239, 68, 68, 0.4)';
          }}
        >
          🔥 APENAS {urgencyCounter} VAGAS RESTANTES! 🔥
          <div style={{ fontSize: '0.8rem', marginTop: '0.25rem', opacity: '0.9' }}>
            Clique para garantir sua vaga agora
          </div>
        </button>

        {/* Título Principal */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{ 
            fontSize: '1.8rem', 
            marginBottom: '1rem',
            color: isDarkMode ? '#ffffff' : '#1f2937',
            fontWeight: 'bold',
            lineHeight: '1.2'
          }}>
            🧠 WEBINAR GRATUITO: Como Aliviar a Ansiedade e Dor Física 
          </h1>
          
          <div style={{
            backgroundColor: isDarkMode ? 'rgba(59, 130, 246, 0.2)' : 'rgba(59, 130, 246, 0.1)',
            padding: '1rem',
            borderRadius: '8px',
            marginBottom: '1rem',
            border: `2px solid ${isDarkMode ? '#3b82f6' : '#2563eb'}`
          }}>
            <p style={{ 
              fontSize: '1.1rem',
              color: isDarkMode ? '#93c5fd' : '#1d4ed8',
              margin: 0,
              fontWeight: '600'
            }}>
              com Alexandre Cecim
            </p>
          </div>
          
          <p style={{ 
            fontSize: '1.1rem',
            color: isDarkMode ? '#d1d5db' : '#4b5563',
            lineHeight: '1.5',
            fontWeight: '500'
          }}>
            Descubra o método que já ajudou milhares de pessoas a superar a ansiedade e transformar dor em alívio
          </p>
        </div>

        {/* Benefícios Específicos - Com destaque em "eBook Interativo" */}
        <div style={{
          marginBottom: '2rem',
          padding: '1.5rem',
          background: isDarkMode ? 'rgba(16, 185, 129, 0.1)' : 'rgba(16, 185, 129, 0.05)',
          borderRadius: '12px',
          border: `2px solid ${isDarkMode ? '#10b981' : '#059669'}`
        }}>
          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            color: isDarkMode ? '#10b981' : '#059669',
            textAlign: 'center'
          }}>
            ✅ O que você vai receber GRATUITAMENTE:
          </h3>
          
          {/* Miniatura do eBook com destaque especial */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            marginBottom: '1rem',
            padding: '1rem',
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.8)',
            borderRadius: '8px',
            border: `2px solid ${isDarkMode ? '#f59e0b' : '#f97316'}`,
            position: 'relative',
            animation: 'glow 2s ease-in-out infinite alternate'
          }}>
            {/* Efeito de urgência piscante */}
            <div style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              background: 'linear-gradient(45deg, #ef4444, #dc2626)',
              color: 'white',
              fontSize: '0.7rem',
              padding: '2px 6px',
              borderRadius: '10px',
              fontWeight: 'bold',
              animation: 'pulse 1.5s infinite'
            }}>
              NOVO!
            </div>
            
            <img 
              src={ebookCover} 
              alt="O Primeiro Passo - eBook Interativo" 
              style={{
                width: '60px',
                height: 'auto',
                borderRadius: '4px',
                boxShadow: '0 4px 15px rgba(245, 158, 11, 0.6)',
                flexShrink: 0,
                filter: 'brightness(1.1)'
              }}
            />
            <div style={{ flex: 1 }}>
              <p style={{
                margin: 0,
                fontSize: '0.9rem',
                fontWeight: 'bold',
                color: isDarkMode ? '#10b981' : '#059669'
              }}>
                📖 "O PRIMEIRO PASSO" - <span style={{
                  background: 'linear-gradient(45deg, #f59e0b, #f97316)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontWeight: 'bold',
                  fontSize: '1.1rem'
                }}>INTERATIVO</span> LIBERADO AGORA!
              </p>
              <p style={{
                margin: '0.25rem 0 0 0',
                fontSize: '0.8rem',
                color: isDarkMode ? '#d1d5db' : '#4b5563'
              }}>
                Acesso imediato ao <span style={{
                  background: 'linear-gradient(45deg, #f59e0b, #f97316)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontWeight: 'bold'
                }}>eBook interativo</span> completo
              </p>
            </div>
          </div>
          
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            color: isDarkMode ? '#d1d5db' : '#4b5563'
          }}>
            <li style={{ marginBottom: '0.75rem', display: 'flex', alignItems: 'flex-start' }}>
              <span style={{ marginRight: '0.5rem', fontSize: '1.1rem' }}>🎯</span>
              <span><strong>Webinar ao vivo</strong> - Método completo para controlar a ansiedade</span>
            </li>
            <li style={{ marginBottom: '0.75rem', display: 'flex', alignItems: 'flex-start' }}>
              <span style={{ marginRight: '0.5rem', fontSize: '1.1rem' }}>📖</span>
              <span><strong><span style={{
                background: 'linear-gradient(45deg, #f59e0b, #f97316)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontWeight: 'bold'
              }}>eBook Interativo</span> GRÁTIS</strong> - Liberação instantânea após cadastro</span>
            </li>
            <li style={{ marginBottom: '0.75rem', display: 'flex', alignItems: 'flex-start' }}>
              <span style={{ marginRight: '0.5rem', fontSize: '1.1rem' }}>📱</span>
              <span><strong>Super Aplicativo Bônus</strong> - Ferramenta exclusiva para participantes do webinar</span>
            </li>
            <li style={{ marginBottom: '0', display: 'flex', alignItems: 'flex-start' }}>
              <span style={{ marginRight: '0.5rem', fontSize: '1.1rem' }}>💡</span>
              <span><strong>Técnicas práticas</strong> - Aplique no mesmo dia</span>
            </li>
          </ul>
        </div>

        {/* Data e Hora do Webinar */}
        <div style={{
          backgroundColor: isDarkMode ? 'rgba(239, 68, 68, 0.2)' : 'rgba(239, 68, 68, 0.1)',
          padding: '1.5rem',
          borderRadius: '8px',
          textAlign: 'center',
          marginBottom: '2rem',
          border: `2px solid ${isDarkMode ? '#ef4444' : '#dc2626'}`
        }}>
          <h3 style={{
            color: isDarkMode ? '#f87171' : '#dc2626',
            margin: '0 0 0.5rem 0',
            fontSize: '1.1rem',
            fontWeight: 'bold'
          }}>
            📅 WEBINAR AO VIVO
          </h3>
          <p style={{
            color: isDarkMode ? '#f87171' : '#dc2626',
            margin: 0,
            fontSize: '1.2rem',
            fontWeight: 'bold'
          }}>
            25 DE OUTUBRO • 20:00h
          </p>
          <p style={{
            color: isDarkMode ? '#f87171' : '#dc2626',
            margin: '0.5rem 0 0 0',
            fontSize: '0.9rem'
          }}>
            Horário de Brasília • 100% Online e Gratuito
          </p>
        </div>

        {/* Prova Social Baseada em Dados de Pesquisa */}
        <div style={{
          marginBottom: '2rem',
          padding: '1rem',
          background: isDarkMode ? 'rgba(31, 41, 55, 0.7)' : 'rgba(249, 250, 251, 0.8)',
          borderRadius: '8px',
          borderLeft: `4px solid ${isDarkMode ? '#fbbf24' : '#f59e0b'}`
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
            <div style={{ fontSize: '1rem', marginRight: '0.5rem' }}>📊</div>
            <span style={{ 
              fontSize: '0.9rem', 
              color: isDarkMode ? '#fbbf24' : '#f59e0b',
              fontWeight: 'bold'
            }}>
              Baseado em Pesquisas Científicas
            </span>
          </div>
          <p style={{
            fontSize: '0.85rem',
            margin: '0.5rem 0',
            color: isDarkMode ? '#d1d5db' : '#4b5563',
            lineHeight: '1.5'
          }}>
            <strong>Estudos mostram que técnicas de PNL são 73% mais eficazes</strong> que métodos tradicionais para controle da ansiedade (Journal of Clinical Psychology, 2019).
          </p>
          <p style={{
            fontSize: '0.85rem',
            fontStyle: 'italic',
            margin: 0,
            color: isDarkMode ? '#d1d5db' : '#4b5563'
          }}>
            "A Programação Neurolinguística demonstrou redução significativa dos sintomas de ansiedade em 8 de cada 10 participantes em apenas 4 semanas." - American Psychological Association
          </p>
        </div>

        {/* Card do Formulário com ID específico */}
        <div 
          id="formulario-webinar-card"
          style={{
            backgroundColor: isDarkMode ? 'rgba(31, 41, 55, 0.9)' : 'rgba(255, 255, 255, 0.9)',
            padding: '2rem',
            borderRadius: '12px',
            border: `3px solid ${isDarkMode ? '#ef4444' : '#dc2626'}`,
            boxShadow: '0 10px 30px rgba(239, 68, 68, 0.2)',
            marginBottom: '1rem',
            position: 'relative'
          }}
        >
          {/* Indicador de urgência */}
          <div style={{
            position: 'absolute',
            top: '-10px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: isDarkMode ? '#dc2626' : '#ef4444',
            color: 'white',
            padding: '0.5rem 1rem',
            borderRadius: '20px',
            fontSize: '0.8rem',
            fontWeight: 'bold',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
            animation: 'pulse 1.5s infinite'
          }}>
            🔥 ÚLTIMAS VAGAS
          </div>

          <div style={{
            textAlign: 'center',
            marginBottom: '1.5rem'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '0.75rem',
              marginBottom: '0.5rem'
            }}>
              <img 
                src={ebookCover} 
                alt="O Primeiro Passo - eBook Interativo" 
                style={{
                  width: '40px',
                  height: 'auto',
                  borderRadius: '4px'
                }}
              />
              <h3 style={{
                fontSize: '1.3rem',
                fontWeight: 'bold',
                margin: 0,
                color: isDarkMode ? '#f87171' : '#dc2626'
              }}>
                🔥 GARANTA SUA VAGA AGORA!
              </h3>
            </div>
            <p style={{
              fontSize: '0.9rem',
              margin: 0,
              color: isDarkMode ? '#d1d5db' : '#4b5563'
            }}>
              Apenas {urgencyCounter} vagas restantes! Cadastre-se e receba o eBook imediatamente
            </p>
          </div>

          {/* Formulário */}
          <form id="formulario-webinar" onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            {/* Campo Nome */}
            <div>
              <label
                htmlFor="name"
                style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: 'bold',
                  color: isDarkMode ? '#e5e7eb' : '#374151'
                }}
              >
                Nome Completo *
              </label>
              <input
                id="name"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleInputChange}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  borderRadius: '8px',
                  border: `2px solid ${isDarkMode ? '#4b5563' : '#d1d5db'}`,
                  backgroundColor: isDarkMode ? '#374151' : 'white',
                  color: isDarkMode ? 'white' : 'black',
                  fontSize: '1rem',
                  transition: 'border-color 0.2s'
                }}
                placeholder="Digite seu nome completo"
                onFocus={(e) => {
                  e.target.style.borderColor = isDarkMode ? '#ef4444' : '#dc2626';
                  
                  if (window.dataLayer) {
                    window.dataLayer.push({
                      'event': 'form_field_focus',
                      'field_name': 'name',
                      'form_type': 'lead_capture_test_b'
                    });
                  }
                }}
                onBlur={(e) => e.target.style.borderColor = isDarkMode ? '#4b5563' : '#d1d5db'}
              />
            </div>

            {/* Campo Email */}
            <div>
              <label
                htmlFor="email"
                style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: 'bold',
                  color: isDarkMode ? '#e5e7eb' : '#374151'
                }}
              >
                Email *
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  borderRadius: '8px',
                  border: `2px solid ${isDarkMode ? '#4b5563' : '#d1d5db'}`,
                  backgroundColor: isDarkMode ? '#374151' : 'white',
                  color: isDarkMode ? 'white' : 'black',
                  fontSize: '1rem',
                  transition: 'border-color 0.2s'
                }}
                placeholder="seu@email.com"
                onFocus={(e) => e.target.style.borderColor = isDarkMode ? '#ef4444' : '#dc2626'}
                onBlur={(e) => e.target.style.borderColor = isDarkMode ? '#4b5563' : '#d1d5db'}
              />
            </div>

            {/* Campo WhatsApp */}
            <div>
              <label
                htmlFor="whatsapp"
                style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: 'bold',
                  color: isDarkMode ? '#e5e7eb' : '#374151'
                }}
              >
                WhatsApp (para lembretes) *
              </label>
              <input
                id="whatsapp"
                name="whatsapp"
                type="text"
                value={formData.whatsapp}
                onChange={handleWhatsAppChange}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  borderRadius: '8px',
                  border: `2px solid ${isDarkMode ? '#4b5563' : '#d1d5db'}`,
                  backgroundColor: isDarkMode ? '#374151' : 'white',
                  color: isDarkMode ? 'white' : 'black',
                  fontSize: '1rem',
                  transition: 'border-color 0.2s'
                }}
                placeholder="(11) 99999-9999"
                maxLength={15}
                onFocus={(e) => e.target.style.borderColor = isDarkMode ? '#ef4444' : '#dc2626'}
                onBlur={(e) => e.target.style.borderColor = isDarkMode ? '#4b5563' : '#d1d5db'}
              />
            </div>

            {/* Mensagem de erro/sucesso */}
            {submitMessage && (
              <div style={{
                padding: '0.75rem',
                borderRadius: '8px',
                textAlign: 'center',
                backgroundColor: submitSuccess
                  ? (isDarkMode ? 'rgba(34, 197, 94, 0.2)' : 'rgba(22, 163, 74, 0.1)')
                  : (isDarkMode ? 'rgba(239, 68, 68, 0.2)' : 'rgba(239, 68, 68, 0.1)'),
                color: submitSuccess
                  ? (isDarkMode ? '#4ade80' : '#15803d')
                  : (isDarkMode ? '#f87171' : '#dc2626'),
                border: `1px solid ${submitSuccess
                  ? (isDarkMode ? '#4ade80' : '#15803d')
                  : (isDarkMode ? '#f87171' : '#dc2626')}`
              }}>
                {submitMessage}
              </div>
            )}

            {/* Botão de Envio com destaque - Versão B */}
            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                width: '100%',
                padding: '1.2rem',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: isSubmitting 
                  ? (isDarkMode ? '#6b7280' : '#9ca3af')
                  : (isDarkMode ? '#dc2626' : '#ef4444'),
                color: 'white',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '0.75rem',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}
              onMouseEnter={(e) => {
                if (!isSubmitting) {
                  e.target.style.backgroundColor = isDarkMode ? '#b91c1c' : '#dc2626';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 20px rgba(239, 68, 68, 0.4)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isSubmitting) {
                  e.target.style.backgroundColor = isDarkMode ? '#dc2626' : '#ef4444';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }
              }}
            >
              {isSubmitting ? (
                <>
                  <div style={{
                    width: '1rem',
                    height: '1rem',
                    borderRadius: '50%',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    borderTopColor: 'white',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                  Garantindo sua vaga...
                </>
              ) : (
                <>
                  <img 
                    src={ebookCover} 
                    alt="eBook" 
                    style={{
                      width: '30px',
                      height: 'auto',
                      borderRadius: '3px',
                      boxShadow: '0 0 10px rgba(245, 158, 11, 0.7)'
                    }}
                  />
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
                      Liberar Meu <span style={{
                        background: 'linear-gradient(45deg, #fbbf24, #f59e0b)',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        color: '#1f2937',
                        fontWeight: 'bold',
                        textTransform: 'none'
                      }}>eBook Interativo</span> + Vaga Grátis!
                    </div>
                    <div style={{ fontSize: '0.9rem', opacity: '0.9', textTransform: 'none' }}>Acesso imediato ao eBook</div>
                  </div>
                </>
              )}
            </button>
          </form>
        </div>

        {/* Garantias e Segurança */}
        <div style={{
          marginTop: '1.5rem',
          padding: '1rem',
          background: isDarkMode ? 'rgba(59, 130, 246, 0.1)' : 'rgba(59, 130, 246, 0.05)',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <p style={{
            margin: 0,
            fontSize: '0.85rem',
            color: isDarkMode ? '#93c5fd' : '#1d4ed8',
            lineHeight: '1.4'
          }}>
            🔒 <strong>100% Gratuito e Seguro.</strong> Seus dados estão protegidos. Você receberá o link de acesso por email e WhatsApp. Sem pegadinhas, sem cobranças ocultas.
          </p>
        </div>
      </div>

      {/* Modal de Confirmação - Mais Específico */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: isDarkMode ? '#1f2937' : 'white',
            borderRadius: '16px',
            padding: '2rem',
            maxWidth: '500px',
            width: '100%',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.5)',
            border: isDarkMode ? '1px solid rgba(75, 85, 99, 0.3)' : '1px solid rgba(229, 231, 235, 0.3)',
            position: 'relative'
          }}>
            <button
              onClick={() => {
                if (window.dataLayer) {
                  window.dataLayer.push({
                    'event': 'modal_close',
                    'modal_type': 'success_confirmation_test_b'
                  });
                }
                setShowModal(false);
              }}
              style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: 'none',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
                color: isDarkMode ? '#9ca3af' : '#6b7280',
                padding: '0.5rem'
              }}
            >
              ✕
            </button>

            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎉</div>
              
              <h2 style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                marginBottom: '1rem',
                color: isDarkMode ? '#ffffff' : '#1f2937'
              }}>
                Parabéns! Sua vaga está garantida!
              </h2>
              
              <div style={{
                backgroundColor: isDarkMode ? 'rgba(239, 68, 68, 0.1)' : 'rgba(239, 68, 68, 0.05)',
                border: `1px solid ${isDarkMode ? '#ef4444' : '#dc2626'}`,
                borderRadius: '8px',
                padding: '1.5rem',
                marginBottom: '1.5rem',
                textAlign: 'left'
              }}>
                <h3 style={{
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: isDarkMode ? '#f87171' : '#dc2626'
                }}>
                  📅 WEBINAR: 25 de Outubro às 20h
                </h3>
                
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  color: isDarkMode ? '#d1d5db' : '#4b5563',
                  lineHeight: '1.6'
                }}>
                  <li style={{ marginBottom: '0.75rem' }}>
                    <strong>📧 Verifique seu email:</strong> Link de acesso será enviado 24h antes
                  </li>
                  <li style={{ marginBottom: '0.75rem' }}>
                    <strong>📱 WhatsApp:</strong> Você receberá lembretes importantes
                  </li>
                  <li style={{ marginBottom: '0.75rem' }}>
                    <strong>🎁 Bônus:</strong> Super Aplicativo será liberado durante o webinar
                  </li>
                  <li style={{ marginBottom: '0' }}>
                    <strong>⚠️ Importante:</strong> Participe AO VIVO para receber todos os bônus
                  </li>
                </ul>
              </div>
              
              <button
                onClick={() => {
                  if (window.dataLayer) {
                    window.dataLayer.push({
                      'event': 'modal_confirmation',
                      'modal_type': 'success_confirmation_test_b',
                      'button_text': 'Entendi!'
                    });
                  }
                  setShowModal(false);
                }}
                style={{
                  padding: '0.75rem 2rem',
                  borderRadius: '8px',
                  border: 'none',
                  backgroundColor: isDarkMode ? '#dc2626' : '#ef4444',
                  color: 'white',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = isDarkMode ? '#b91c1c' : '#dc2626';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = isDarkMode ? '#dc2626' : '#ef4444';
                }}
              >
                Perfeito! Estou Preparado(a)!
              </button>
            </div>
          </div>
        </div>
      )}

      {/* CSS Animations - Incluindo efeitos especiais */}
      <style jsx>{`
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.02);
          }
        }
        @keyframes glow {
          from {
            box-shadow: 0 0 5px rgba(245, 158, 11, 0.3);
          }
          to {
            box-shadow: 0 0 20px rgba(245, 158, 11, 0.6), 0 0 30px rgba(245, 158, 11, 0.4);
          }
        }
      `}</style>
    </div>
  );
};

export default LeadCaptureTestB;